import { type AdminAgentNoteStatsResponse } from '@libraries/typescript/api_client';

function formatSeconds(value: number | null): string {
    if (value === null) {
        return '—';
    }
    if (value < 10) {
        return `${value.toFixed(1)}s`;
    }
    if (value < 120) {
        return `${Math.round(value)}s`;
    }
    return `${(value / 60).toFixed(1)}m`;
}

/**
 * Per-transition latency percentiles: captured → classified and
 * classified → routed, each as p50 / p95 / p99.
 */
export function StageLatencyCard({
    stats,
}: {
    readonly stats: AdminAgentNoteStatsResponse;
}) {
    const latency = stats.latency;
    const rows = [
        {
            label: 'Captured → Classified',
            p50: latency.p50_classify_seconds,
            p95: latency.p95_classify_seconds,
            p99: latency.p99_classify_seconds,
        },
        {
            label: 'Classified → Completed',
            p50: latency.p50_route_seconds,
            p95: latency.p95_route_seconds,
            p99: latency.p99_route_seconds,
        },
    ];
    return (
        <div className="flex flex-col gap-2">
            <div className="grid grid-cols-[minmax(0,1fr)_56px_56px_56px] gap-y-2 text-xs">
                <span />
                <span className="text-muted-foreground text-right">p50</span>
                <span className="text-muted-foreground text-right">p95</span>
                <span className="text-muted-foreground text-right">p99</span>
                {rows.map((row) => (
                    <div key={row.label} className="contents">
                        <span className="text-muted-foreground truncate">
                            {row.label}
                        </span>
                        <span className="text-right font-medium tabular-nums">
                            {formatSeconds(row.p50)}
                        </span>
                        <span className="text-right font-medium tabular-nums">
                            {formatSeconds(row.p95)}
                        </span>
                        <span className="text-right font-medium tabular-nums">
                            {formatSeconds(row.p99)}
                        </span>
                    </div>
                ))}
            </div>
            <p className="text-muted-foreground text-[11px]">
                {latency.classified_count} notes classified in range
            </p>
        </div>
    );
}
